import { defineMessages } from 'react-intl';

export default defineMessages({
    addVehicleButton: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.addVehicleButton',
        defaultMessage: 'ADD VEHICLE'
    },
    missingFields: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.missingFields',
        defaultMessage: 'Please complete all required fields'
    },
    hasBeenRemoved: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.hasBeenRemoved',
        defaultMessage: 'has been removed.'
    },
    trailerError: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.trailerError',
        defaultMessage: 'A trailer cannot be the only vehicle on the policy.'
    },
    duplicateVinError: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.duplicateVinError',
        defaultMessage: 'More than one vehicle cannot have the same vin'
    },
    altAddressError: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.altAddressError',
        defaultMessage: 'Alternate garage address must be in the same state as primary address'
    },
    missingCommuteError: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.missingCommuteError',
        defaultMessage: 'One or more drivers are listed as employed and no vehicles are listed as commute to work or business use. Please review and update if needed.'
    },
    missingBusinessUseError: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.missingBusinessUseError',
        defaultMessage: 'One or more drivers are listed as employed and no vehicles are listed as business use. Please review and update if needed.'
    },
    nextGatherAdditionalInfo: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.nextGatherAdditionalInfo',
        defaultMessage: 'Next, we will gather some {addlInfo}'
    },
    additionalInformation: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.additionalInformation',
        defaultMessage: 'additional information'
    },
    nextVehicles: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.nextVehicles',
        defaultMessage: 'Next, we\'ll work on {addlVehicles}'
    },
    additionalVehicles: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.additionalVehicles',
        defaultMessage: 'additional vehicles'
    },
    alertMessage: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.alertMessage',
        defaultMessage: '{object} {message}'
    },
    undo: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.Undo',
        defaultMessage: 'Undo'
    },
    vehicles: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.Vehicles',
        defaultMessage: 'Vehicles'
    },
    noVehiclesDesc: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.noVehiclesDesc',
        defaultMessage: 'No vehicles are currently covered on this quote.  If none are included, the drivers listed on this quote will be covered for Liability insurance only when they drive vehicles they don\'t own.  If any driver owns a vehicle, please add the vehicle now.'
    },
    fieldsNotComplete: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.Please complete all required fields',
        defaultMessage: 'Please complete all required fields'
    },
    validate: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.validate',
        defaultMessage: 'validate'
    },
    validationNext: {
        id: 'ml.gateway.quoteandbind.pa.vehicles.validationNext',
        defaultMessage: 'Next, we\'ll {validate} all information provided'
    },
    somethingWentWrong: {
        id: 'ml.agent.quoteandbind.pa.vehicles.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    trailerorCamperError: {
        id: "ml.gateway.quoteandbind.pa.vehicles.trailerorCamperError",
        defaultMessage: "A trailer or camper cannot be the only vehicle on the policy."
    },
    vehicleUseStorageError : {
        id: "ml.gateway.quoteandbind.pa.vehicles.vehicleUseStorageError",
        defaultMessage: "A policy cannot have all vehicles primarily used for storage. Please update the usage for one of the vehicles."
    },
    vehicleUseBusinessError : {
        id: "ml.gateway.quoteandbind.pa.vehicles.vehicleUseBusinessError",
        defaultMessage: "A policy cannot have more than two vehicles primarily used for business. Please update the usage for one or more vehicles to proceed. Campers and trailers are excluded from this count."
    },
    costNewRequired: {
        id: "ml.gateway.quoteandbind.pa.vehicles.costNewRequired",
        defaultMessage: "Please enter a valid costNew amount"
    },
    maxTwoYearsAllowedForPurchaseYearNP: {
        id: 'ml.quoteandbind.views.contact-us.maxTwoYearsAllowedForPurchaseYearNP',
        defaultMessage: 'Change the Purchase Date. Year purchased cannot be more than 2 years prior to model year for Vehicle {vehicleName}'
    },

});
